import {StringUtil} from './StringUtil';
export const RegexUtil = {
  /**
   * 不为空（空字符串， 'null', 'undefined', Date, object(Array, Object)）
   * 如果是对象，则可以使用不验证某些对象key参数excludeKeys
   */
  isEmpty (val, excludeKeys) {
    if (!val) {
      return true;
    }
    if (typeof val === 'string') {
      if (StringUtil.trim(val) === '') {
        return true;
      }
      if (val === 'null') {
        return true;
      }
      if (val === 'undefined') {
        return true;
      }
    }
    if (typeof val === 'object') {
      if (Array.isArray(val) && val.length === 0) {
        return true;
      } else if (val instanceof Date) {
        return false;
      } else {
        excludeKeys = excludeKeys || [];
        for (let e in val) {
          if (excludeKeys.indexOf(e) === -1 && val[e]) {
            return false;
          }
        }
        return true;
      }
    }
    return false;
  },
  isNumberEmpty (val, excludeKeys) {
    if (!val) {
      return true;
    }
    if (val === '0' || val === 0) {
      return true;
    }
    if (typeof val === 'string') {
      if (StringUtil.trim(val) === '') {
        return true;
      }
      if (val === 'null') {
        return true;
      }
      if (val === 'undefined') {
        return true;
      }
    }
    if (typeof val === 'object') {
      if (Array.isArray(val) && val.length === 0) {
        return true;
      } else if (val instanceof Date) {
        return false;
      } else {
        excludeKeys = excludeKeys || [];
        for (let e in val) {
          if (excludeKeys.indexOf(e) === -1 && val[e]) {
            return false;
          }
        }
        return true;
      }
    }
    return false;
  },
  /**
   * 金额验证
   * @param val
   * @returns {boolean}
   */
  isMoney (val) {
    let pattern = /(^[1-9]([0-9]+)?(\.[0-9]{1,3})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9]{1,2})?$)/;
    if (!pattern.test(val)) {
      return false;
    }
    return true;
  },
  /**
   * 是否是Promise对象
   * @param val
   * @returns {*|boolean}
   */
  isPromise (val) {
    return val && typeof val.then === 'function';
  },
  /**
   * is object
   * @param obj
   * @returns {boolean}
   */
  isObject (obj) {
    return obj !== null && typeof obj === 'object';
  },
  /**
   * 验证对象是否是数组类型
   * @param value
   * @returns {*}
   */
  isArray (value) {
    if (typeof Array.isArray === 'function') {
      return Array.isArray(value);
    } else {
      return Object.prototype.toString.call(value) === '[object Array]';
    }
  },
  /**
   * 是否为整数
   * @param val
   * @returns {boolean}
   */
  isInteger (val) {
    let ex = /^\d+$/;
    if (ex.test(val)) {
      return true;
    }
    return false;
  },
  /**
   * 是否正数
   * @param val
   * @returns {boolean}
   */
  isPositiveNumber (val) {
    if (this.isInteger(val) && val > 0) {
      return true;
    }
    return false;
  },
  /**
   * 验证手机号的合法性
   * @param num
   * @returns {boolean}
   */
  isMobileNum (num) {
    if (typeof num === 'undefined' || num === null || num === '') return false;
    let numbers = /^1\d{10}$/;
    let val = num.replace(/\s+/g, ''); // 获取输入手机号码
    if (!numbers.test(val) || val.length !== 11) {
      return false;
    } else {
      return true;
    }
  },
  /**
   * 固定电话
   * @param val
   * @returns {boolean}
   */
  isTelePhoneNum (val) {
    let reg = /^0\d{2,3}-?\d{7,8}$/;
    if (reg.test(val)) {
      return true;
    }
    return false;
  },
  /**
   * 固定电话或移动电话
   * @param val
   * @returns {boolean}
   */
  isPhoneNum (val) {
    if (this.isTelePhoneNum(val) || this.isMobileNum(val)) {
      return true;
    }
    return false;
  },
  /**
   * @param {string} email
   * @returns {Boolean}
   */
  isEmail(email) {
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return reg.test(email)
  },
  /**
   * 验证身份证号格式--简易认证
   */
  isIDNo (val) {
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x|Y|y)$)/;
    if (reg.test(val)) {
      return true;
    }
    return false;
  },
  /**
   * 非负数验证
   * @param val
   * @returns {boolean}
   */
  isDigit (val) {
    let pattern = /^\d+(\.\d+)?$/;
    if (!pattern.test(val)) {
      return false;
    }
    return true;
  },
  /**
   * 判断是否是数字
   */
  isNumber (val) {
    let pattern = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g; // /^(-?\d+)(\.\d+)?$/;
    if (pattern.test(val)) {
      return true;
    }
    return false;
  },
  /**
   * 判断是否是数值
   */
  isDecimal (val) {
    let pattern = /(^(-?)[1-9]([0-9]+)?(\.[0-9]{1,28})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    if (!pattern.test(val)) {
      return false;
    }
    return true;
  },
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  isString(str) {
    if (typeof str === 'string' || str instanceof String) {
      return true
    }
    return false
  },
  /** 是否英文字母
   * @param {string} str
   * @returns {Boolean}
   */
  isAlphabets(str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
  },
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  isLowerCase(str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
  },
  /**
   * @param {string} str
   * @returns {Boolean}
   */
  isUpperCase(str) {
    const reg = /^[A-Z]+$/;
    return reg.test(str)
  },
  /**
   * 判断是否是图片
   */
  isImage (fileName) {
    if (/.(gif|jpg|jpeg|png|gif|jpg|png)$/i.test(fileName)) {
      return true;
    }
    return false;
  },
  /**
   * @param {string} path
   * @returns {Boolean}
   */
  isExternal(path) {
    return /^(https?:|http:|mailto:|tel:)/.test(path)
  },
  /**
   * @param {string} url
   * @returns {Boolean}
   */
  isURL(url) {
    const reg = /^(https?|http|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
  },
  /**
   * 校验密码强度
   * @param {string} pwd
   * @returns {Boolean}
   */
  isValidPassword(pwd) {
    //最低 密码只能包含数字，长度是8到18位

    //低 密码只能包含包含字母、数字，长度是8到30位
    // const reg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{8,30}');

    //中 密码必须包含字母、数字、特殊字符，长度是8到30位
    // const reg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}');

    //高 密码必须包含大小写字母、数字和特殊字符，长度是8到18位
    const reg = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,30}');
    return reg.test(pwd);
  },
  /**
   * 判断是否是移动端环境
   * @returns {boolean}
   */
  isMobile() {
    let flag = window.matchMedia("(max-width: 625px)").matches;
    return flag;
  },
  /**
   * 判断是否是微信环境
   * @returns {boolean}
   */
  isWeChat() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('micromessenger') > -1) {
      return true;
    }
    return false;
  },
  /**
   * 判断是否是支付宝环境
   * @returns {boolean}
   */
  isAliPay() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('alipayclient') > -1) {
      return true;
    }
    return false;
  },
  async isBlob(data) {
    try {
      const text = await data.text();
      JSON.parse(text);
      return false;
    } catch (error) {
      return true;
    }
  }

};

// 验证是否为blob格式
// export async function blobValidate(data) {
//   try {
//     const text = await data.text();
//     JSON.parse(text);
//     return false;
//   } catch (error) {
//     return true;
//   }
// }
